<div class="curbside-space-number-popup">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h4 class="mg-btm-32">Select Your Curbside Number</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <select class="form-control custom-select" [(ngModel)]="selectedCurbsideSpace" (change)="setCurbsideSpace()">
        <option hidden value="" disabled></option>
        <option  *ngFor="let cs of checkIn.checkInOption.parkingSpaces" [ngValue]="cs">{{cs}}</option>
    </select>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mg-top-24">
      <button (click)='checkInWithSpace(selectedCurbsideSpace?.toString(), CheckInType.Curbside)' class="btn wb-btn-default center-block" [disabled]="!isCurbsideSpaceSelected || checkIn.loading">Check In</button>
      <span role="button" (click)="cancelCheckIn()" class="btn wb-btn-outline">Cancel</span>
    </div>    
  </div>  